import { Component, OnInit } from '@angular/core';
import { DemonstrativoImpostoRenda } from '../../../shared/model/demonstrativo-imposto-renda.model';
import { DemonstrativoImpostoRendaService } from '../../../shared/service/demonstrativo-imposto-renda.service';
import { Subscription } from 'rxjs';
import { Navegador } from '../../../shared/navegador/navegador';
import { DownloadAutomatico } from '../../../shared/arquivo/download-automatico';

@Component({
  selector: 'app-consumidor-demonstrativo-imposto-renda',
  templateUrl: './consumidor-demonstrativo-imposto-renda.component.html',
  styleUrls: ['./consumidor-demonstrativo-imposto-renda.component.css']
})
export class ConsumidorDemonstrativoImpostoRendaComponent implements OnInit {

  public haRegistros = true;
  // Mensagens:
  public msgNotificacaoNenhumPremio: string = 'O Demonstrativo de IRRF fica disponível apenas para os cidadãos premiados com pagamento a partir de 2023.';
  public msgInfoAnoCalendario: string = 'O ano-calendário refere-se ao período do recebimento efetivo da premiação da Campanha Nota Premiada Bahia.';

  public demonstrativos: DemonstrativoImpostoRenda[] = [];

  public MensagemErro: string = "";

  constructor(private readonly demonstrativoImpostoRendaService: DemonstrativoImpostoRendaService    
    ) { }

  ngOnInit() {
    this.obterListaDemonstrativos();
  }

  private obterListaDemonstrativos() {
    
    let idConsumidor = JSON.parse(localStorage.getItem('consumidor'))['consumidorId'];
    
    this.demonstrativoImpostoRendaService.obterDemostrativos(idConsumidor);

    const s: Subscription = this.demonstrativoImpostoRendaService.demostrativoChange.subscribe(
      (data: Array<DemonstrativoImpostoRenda>) => {

        this.demonstrativos  = data;

        if(this.demonstrativos.length > 0) {
          this.haRegistros = true;
        } else {
          this.haRegistros = false;        
        }
      },
      erro => {
        s.unsubscribe();
      },
      () => {

        s.unsubscribe();
      }
    );

  }

  private baixar (anoCalendario: number) {
    this.MensagemErro = "";
    let idConsumidor = JSON.parse(localStorage.getItem('consumidor'))['consumidorId'];

    this.demonstrativoImpostoRendaService.downloadArquivoDemonstrativo(idConsumidor, anoCalendario).subscribe(res => {

        const nomeArquivo = res.filename.toString();

        if(Navegador.ehInternetExplorer() || Navegador.ehEdge()) {

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([res.data]), nomeArquivo);
          }

        }else {

            DownloadAutomatico.RealizarDownload(res.data, nomeArquivo);
        }

      }, error => {                
        this.MensagemErro = "Se houver dificuldade em baixar o arquivo para fins de IRRF, entrar em contato para orientação por meio dos seguintes telefones: (71) 3115-8835/5078/2518.";        
      });
  }
 
}


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-demonstrativo-imposto-renda/consumidor-demonstrativo-imposto-renda.component.ts